import {
    API_ROUTES,
    CHAT_COMMANDS,
    CHAT_READ_CURSOR_COMMANDS,
    CHAT_RESOLVERS,
    CORPORATION_COMMANDS,
    CORPORATION_RESOLVERS,
    DIVISION_COMMANDS,
    DIVISION_RESOLVERS,
    LOAN_REQUEST_APPLICANT_EDITING_COMMANDS,
    LOAN_REQUEST_COMMANDS,
    LOAN_REQUEST_RESOLVERS,
    PARTNER_RESOLVERS,
    SYSTEM_VARIABLE_COMMANDS,
    SYSTEM_VARIABLE_RESOLVERS,
    TEAM_COMMANDS,
    TEAM_RESOLVERS,
    TEMPLATE_COMMANDS,
    TEMPLATE_RESOLVERS,
    USER_COMMANDS,
    USER_RESOLVERS,
    WABA_RESOLVERS,
} from 'cpool-constants';
import type { SchemaUserResolver_GetAclPermissions } from 'cpool-tables/backend-resolvers';
import { objectKeys } from 'cpool-utils';

const setAll = <T extends Record<string, unknown>>(obj: T, value: boolean): { [K in keyof T]: boolean } =>
    Object.fromEntries(objectKeys(obj).map((k) => [k, value])) as { [K in keyof T]: boolean };

const applicantEditingSet = objectKeys(LOAN_REQUEST_APPLICANT_EDITING_COMMANDS);

const buildLoanRequestCommands = (value: boolean) => {
    const entries = objectKeys(LOAN_REQUEST_COMMANDS).map((k) => {
        const cmd = LOAN_REQUEST_COMMANDS[k];
        return applicantEditingSet.includes(cmd as keyof typeof LOAN_REQUEST_APPLICANT_EDITING_COMMANDS)
            ? [
                  k,
                  {
                      applicant1: value,
                      applicant2: value,
                  },
              ]
            : [k, value];
    });
    return Object.fromEntries(entries);
};

export const buildAclPermissions = (value: boolean): SchemaUserResolver_GetAclPermissions => ({
    api: setAll(API_ROUTES, value),
    commands: {
        chat: setAll(CHAT_COMMANDS, value),
        'chat-read-cursor': setAll(CHAT_READ_CURSOR_COMMANDS, value),
        corporation: setAll(CORPORATION_COMMANDS, value),
        division: setAll(DIVISION_COMMANDS, value),
        'loan-request': buildLoanRequestCommands(value),
        partner: {},
        'system-variable': setAll(SYSTEM_VARIABLE_COMMANDS, value),
        team: setAll(TEAM_COMMANDS, value),
        template: setAll(TEMPLATE_COMMANDS, value),
        user: setAll(USER_COMMANDS, value),
        waba: {},
    },
    resolvers: {
        chat: setAll(CHAT_RESOLVERS, value),
        'chat-read-cursor': {},
        corporation: setAll(CORPORATION_RESOLVERS, value),
        division: setAll(DIVISION_RESOLVERS, value),
        'loan-request': setAll(LOAN_REQUEST_RESOLVERS, value),
        partner: setAll(PARTNER_RESOLVERS, value),
        'system-variable': setAll(SYSTEM_VARIABLE_RESOLVERS, value),
        team: setAll(TEAM_RESOLVERS, value),
        template: setAll(TEMPLATE_RESOLVERS, value),
        user: setAll(USER_RESOLVERS, value),
        waba: setAll(WABA_RESOLVERS, value),
    },
});
